module.exports = __webpack_public_path__ + "899e5cc5edbad20c572c473cb95cea97.svg";